import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch (e) {
      localStorage.removeItem("rivaco_token");
      setUser(null);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("rivaco_token");
    if (!token) {
      setLoading(false);
      return;
    }
    fetchMe().finally(() => setLoading(false));
  }, []);

  // finalizeLogin: called by Login page AFTER (single-step OR two-step MFA) returns a token payload
  const finalizeLogin = (data) => {
    localStorage.setItem("rivaco_token", data.token);
    setUser({
      id: data.id,
      email: data.email,
      username: data.username,
      name: data.name,
      role: data.role || "owner",
      must_change_password: !!data.must_change_password,
      must_setup_2fa: !!data.must_setup_2fa,
      totp_enabled: !!data.totp_enabled,
      email_verified: !!data.email_verified,
    });
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("rivaco_token");
    setUser(null);
  };

  const refreshUser = async () => { await fetchMe(); };

  const isOwner = user?.role === "owner";
  const isManager = user?.role === "manager";
  const isCashier = user?.role === "cashier";
  const isAdmin = isOwner || isManager;

  return (
    <AuthContext.Provider value={{ user, loading, finalizeLogin, logout, refreshUser, isOwner, isManager, isCashier, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
